// extracted by mini-css-extract-plugin
module.exports = {"ThemeListContainer":"Perspectives_ThemeListContainer__2ScLp","ThemeListItem":"Perspectives_ThemeListItem__24rSB","infoCont":"Perspectives_infoCont__3H87N"};